import { render, staticRenderFns } from "./PreviewMessage.vue?vue&type=template&id=59d46ada&scoped=true&"
import script from "./PreviewMessage.vue?vue&type=script&lang=js&"
export * from "./PreviewMessage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMessage.vue?vue&type=style&index=0&id=59d46ada&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d46ada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VIcon,VImg,VRow})
